declare global {
  interface Window {
    __MEDIA_DEBUG__?: Array<{ time: number; msg: string }>;
  }
}

const MAX_LOG = 50;
const MEDIA_DEBUG_STORAGE_KEY = 'media_debug';

function isMediaDebugEnabled() {
  if (typeof window === 'undefined') return false;

  const { hostname } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return true;

  try {
    return window.localStorage.getItem(MEDIA_DEBUG_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function mediaDebugLog(...args: any[]) {
  if (typeof window === 'undefined' || !isMediaDebugEnabled()) return;

  const msg = args.map((arg) => {
    try {
      return typeof arg === 'object' ? JSON.stringify(arg) : String(arg);
    } catch {
      return String(arg);
    }
  }).join(' ');

  // eslint-disable-next-line no-console
  console.log('[media]', msg);

  if (!window.__MEDIA_DEBUG__) {
    window.__MEDIA_DEBUG__ = [];
  }

  window.__MEDIA_DEBUG__.push({
    time: Date.now(),
    msg,
  });

  if (window.__MEDIA_DEBUG__.length > MAX_LOG) {
    window.__MEDIA_DEBUG__.shift();
  }
}
